export function SumNumber(array: number[]): number {
  return array.map(ToNumber).reduce((a, b) => a + b, 0);
}

export function ToNumber(x: any) {
  try {
    const parsed = parseFloat(x as any);
    if (!isNaN(parsed)) {
      return parsed;
    }
    return 0;
  } catch {
    return 0;
  }
}

export function UniquIdList(a: { Id: string }[], b: { Id: string }[]): Array<any> {
  return a.concat(b.filter((i) => !a.map((d) => d.Id).includes(i.Id)));
}

export function GenerateNumbers(start: number, end: number): number[] {
  return Array.from({ length: end + 1 }, (_, i) => i).filter((x) => x >= start);
}

export function GenerateNumberOptions(start: number, end: number): { value: string }[] {
  return GenerateNumbers(start, end).map((x) => {
    return { value: x.toString() };
  });
}

export function chunk<T>(array: T[], chunkSize: number): T[][] {
  const output: T[][] = [];
  return output.concat.apply(
    [],
    array.map(function (_, i) {
      return i % chunkSize ? [] : [array.slice(i, i + chunkSize)];
    })
  );
}

export const onlyUnique = (value: any, index: any, self: string | any[]) => self.indexOf(value) === index;

export const onlyUniqueNonBlank = (value: any, index: any, self: string | any[]) =>
  !!value && onlyUnique(value, index, self);
